module.exports = __webpack_public_path__ + "static/media/0.defa2b3a.svg";